var data = {
  "body": "<path fill=\"currentColor\" d=\"M3 3h18v4H3V3m1 5h16v13H4V8m5.5 3a.5.5 0 0 0-.5.5V13h6v-1.5a.5.5 0 0 0-.5-.5h-5Z\"/>",
  "width": 24,
  "height": 24
};
export default data;